{"lon0": -65.0, "lon1": -64.15, "lat0": 18.2, "lat1": 18.8, "w": 897, "h": 663, "dirs": 16, "unit": "km*10", "cap_km": 25.0}